export class Record
{
	setProperties(object)
	{
		if (!object)
			return;

		for (let k in object)
			if (object.hasOwnProperty(k))
				this[k] = object[k];
	}
}

window.App = window.App || {};
window.App.Record = Record;
